import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './AuthDialog.scss';

import {
    Dialog,
    ButtonLink
} from 'components/controls';

import ForgotPasswordContainer from './ForgotPassword/ForgotPasswordContainer';


export default class ForgotPasswordDialog extends Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        onBackClick: PropTypes.func.isRequired,
        forgotPassword: PropTypes.any
    };


    render() {
        const {onClose} = this.props;
        return (
            <Dialog title={this.renderTitle()}
                    dialogClassName={styles.dialog}
                    headerClassName={styles.headerWrapper}
                    containerClassName={styles.restoreDialogBody}
                    onClose={onClose}>
                <ForgotPasswordContainer/>
            </Dialog>
        );
    }

    renderTitle() {
        const {onBackClick, forgotPassword} = this.props;
        if (forgotPassword)
            return (
                <div className={styles.header}>
                    <div className={styles.smallLogo}/>
                    <div className={styles.infoText}>Thank you!</div>
                </div>
            );
        return (
            <div className={styles.header}>
                <ButtonLink className={styles.backButton} onClick={onBackClick}/>
                {loc('forgot-password-dialog-header')}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/ForgotPasswordDialog.js